import { cn } from '@/lib/utils';

/** The wordmark: an "F" cut from a bone square, with the accent tick. Inline SVG, no asset. */
export function FnkMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={cn('h-7 w-7', className)} aria-hidden="true">
      <rect width="32" height="32" rx="3" fill="#f2efe8" />
      <path d="M8 7h16v4H13v4h9v4h-9v6H8z" fill="#0c0d0f" />
      <rect x="23" y="21" width="4" height="4" fill="#ff6b2c" />
    </svg>
  );
}
